module.exports = __webpack_public_path__ + "img/medium-b.fc5fee68.png";